import './loading.less';
import Waiting from './loading-waiting'
import Success from './loading-success'

var Loading = {
  show: function (options) {
    Waiting.show(options);
  },
  hide: function () {
    Waiting.hide();
  },
  success: function (el, options) {
    // eslint-disable-next-line
    return new Success(el, options);
  }
};

export default Loading



// WEBPACK FOOTER //
// ./packages/components/loading/loading.js